import { Drawer, Row, Col, message } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import { useHistory } from "react-router-dom";
import { processSync } from "../../Sync/syncData";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import Close from "../../../assets/images/close-x.svg";
import Logout from "../../../assets/images/logout-new.svg";
import SyncSide from "../../../assets/images/sideFullSync.svg";
import openDrawerIcon from "../../../assets/images/openDrawer.svg";
import unlinkTillIcon from "../../../assets/images/unlink-icon.svg";
import messages from "../../../errors/messages.en-IN.json";
import useSessionStore from "../../../stores/useSessionStore";
import useAuthStore from "../../../stores/useAuthStore";

const SideMenuDrawer = ({
  tillLink,
  setTillLink,
  searchInputRef,
  setActiveInput,
  tillData,
  cart,
  setCart,
  posConfig,
  isOnline,
  selectedSaleTypeData,
  confirmUnlink,
  errorMessage,
  handleCancel,
  setSyncLoad,
  resetProgress,
  version_number,
  removeCustomer,
}) => {
  const history = useHistory();
  const domainURL = process.env.REACT_APP_domain;

  return (
    <Drawer
      placement="left"
      width="20%"
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={POSLogo} style={{ height: "2vw" }} />
          <img
            src={Close}
            onClick={() => {
              setTillLink(false);
              setActiveInput("search");
              if (searchInputRef?.current) {
                searchInputRef.current.focus();
              }
            }}
            style={{
              marginLeft: "auto",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      headerStyle={{ background: "#F3F4F9", borderBottom: "none" }}
      styles={{ body: { background: "#F3F4F9", paddingTop: 0, borderRadius: "none" } }}
      open={tillLink}
      onClose={() => {
        setTillLink(false);
        setActiveInput("search");
        if (searchInputRef?.current) {
          searchInputRef.current.focus();
        }
      }}
    >
      <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
        <Col span={24}>
          <Scrollbars style={{ height: "80vh" }}>
            <Row>
              <Col
                span={1}
                style={{
                  cursor: "pointer",
                  display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                }}
              />
              <Col
                onClick={confirmUnlink}
                style={{
                  cursor: "pointer",
                  display: tillData.tillAccess.unlinkTill === "Y" ? "flex" : "none",
                  alignItems: "center",
                  marginBottom: "2vh",
                }}
                span={22}
              >
                <img src={unlinkTillIcon} style={{ height: "2.5vh" }} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Unlink Till
                </span>
              </Col>
              <Col
                span={1}
                style={{
                  cursor: "pointer",
                  display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                }}
              />
              <Col
                span={1}
                style={{
                  display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                }}
              />
              <Col
                span={22}
                onClick={async () => {
                  if (isOnline) {
                    if (cart.items.length === 0) {
                      useSessionStore.getState().setLastUpdatedTime(null);
                      setTillLink(false);
                      setSyncLoad(true);
                      let tillDataLocal = useAuthStore.getState().tillData;
                      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillDataLocal.tillAccess.csBunit.b2cCustomer;
                      setCart({ ...cart, customer: defaultCustomer });
                      try {
                        await processSync(tillDataLocal, "Full Sync");
                        window.location.reload();
                      } catch (e) {
                        console.warn("[EstimateSideMenu] Full sync failed:", e?.message);
                        message.error("Sync failed. Please check your network and try again.");
                      }
                      setSyncLoad(false);
                      resetProgress();
                    } else {
                      message.error(`${messages.errors.sync.clear_cart_for_sync}`);
                    }
                  } else {
                    errorMessage(`${messages.errors.sync.sync_failed}`, `${messages.errors.sync.network_error}`);
                  }
                }}
                style={{
                  cursor: "pointer",
                  display: posConfig?.enableFullSync === "Y" ? "flex" : "none",
                  alignItems: "center",
                  marginBottom: "2vh",
                }}
              >
                <img src={SyncSide} style={{ height: "2vh" }} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Full Sync
                </span>
              </Col>
              <Col
                span={1}
                style={{
                  display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                }}
              />
              <Col
                span={1}
                style={{
                  display: posConfig?.enableAggregator === "Y" ? "block" : "none",
                }}
              />
              <Col
                span={22}
                onClick={() => {
                  history.push("/aggregator");
                }}
                style={{
                  cursor: "pointer",
                  display: posConfig?.enableAggregator === "Y" ? "flex" : "none",
                  alignItems: "center",
                  marginBottom: "2vh",
                }}
              >
                <img src={openDrawerIcon} style={{ height: "2vh" }} alt="" />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: "1.2em",
                    paddingLeft: "1vw",
                    color: "#0F0718",
                  }}
                >
                  Aggregator
                </span>
              </Col>
              <Col
                span={1}
                style={{
                  display: posConfig?.enableAggregator === "Y" ? "block" : "none",
                }}
              />
            </Row>
          </Scrollbars>
        </Col>
        <Col
          span={24}
          style={{
            width: "80%",
            borderTop: "1px solid #929098",
            position: "absolute",
            bottom: "2.5vh",
            padding: "1vh 1vw",
          }}

        >
          <Row>
            <Col span={1} />
            <Col
              style={{ display: "flex", alignItems: "center", cursor: "pointer", paddingTop: "1vh", marginBottom: 0 }}
              onClick={async () => {
                const cartItems = (cart?.items || []).filter((item) => item.weight !== 0);
                if (cartItems && cartItems.length > 0) {
                  message.warning("Please clear the cart before logging out");
                  return;
                }
                const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
                for (let i = 0; i < cookiesToDelete.length; i++) {
                  const cookie = cookiesToDelete[i];
                  const eqPos = cookie.indexOf("=");
                  const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domainURL}`;
                }
                useSessionStore.getState().setTillSession(null);
                useAuthStore.getState().logout();
                // BUG-2026: await the shell's logout IPC before navigating — it's
                // the authoritative teardown; firing-and-forgetting it raced the redirect.
                await window.electronAPI?.auth?.logout();
                handleCancel();
                removeCustomer();
                window.location.assign("/sign-in");
              }}
              span={20}
            >
              <img src={Logout} alt="" />
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 500,
                  fontSize: "1.2em",
                  paddingLeft: "1vw",
                  color: "#0F0718",
                }}
              >
                Logout
              </span>
            </Col>
            <Col span={24} style={{ position: "absolute", bottom: "5vh", right: "0" }}>
              <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
};

export default SideMenuDrawer;
